<template>
    <div class="article-item-wrap regular-item" @click="openItem">
            <div class="image-wrap">
                <img class="img" :src="itemData.images[0]">
            </div>
            <div class="details-wrap">
                <span class="article-name">{{ itemData.name }}</span>
                <div class="price-wrap">
                    <span class="currency-wrap">RD$</span>
                    <span class="price-value">{{ itemData.price | currency }}</span>
                </div>
                <div class="stars-wrap">
                    <div class="star" v-for="n in 5" :key="n">
                        <img  v-if="itemData.stars < n" src="../../assets/images/empty-star.png">
                        <img  v-else src="../../assets/images/star.png">
                    </div>
                </div>
            </div>
    </div>    
</template>

<script>
export default {
    name: 'market-item',
    props: {
        itemData: Object
    },
    methods: {
        openItem: function() {
            this.$route.router.go({name: 'ProductDetailDevices', params: {something: 'woww'}});
        }
    }
}
</script>

<style scoped>
    .article-item-wrap {
        background-color: #fff;
        border: 1px solid #ddd;
        padding: 20px;
        border-radius: 3px;
        display: flex;
        flex-flow: column wrap;
        width: 100%;
        min-width: 200px;
        margin: 0 5px 10px 5px;
    }

    .article-item-wrap:nth-child(4n+1) {
        margin-left: 0;
    }

    .article-item-wrap:nth-child(4n+4),
    .article-item-wrap:last-child {
         margin-right: 0;
    }

    .image-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 157px;
    }

    .image-wrap img {
        height: 100%;
        width: auto;
    }

    .details-wrap {
        flex: 1;
        padding-top: 15px;
        text-align: left;
    }

    .stars-wrap {
        display: flex;
    }

    .stars-wrap img {
        width: 10px;
        height: 10px;
        margin-right: 3px;
    }

    span.article-name {
        font-size: 13px;
    }

    .price-wrap {
        display: flex;
    }

    .currency-wrap {
        display: flex;
        align-items: center;
        font-size: 9px;
    }

    .price-value {
        margin: 0 3px;
    }
    
    .price-decimals {
        display: flex;
        align-items: flex-end;
        font-size: 9px;
    }

    @media (max-width: 1250px) {
        .article-item-wrap {
            margin-left:5px;
           margin-right:5px;
        }
    }

    @media (max-width: 1270px) {
        .article-item-wrap:nth-child(4n+1) {
           margin-left:5px;
           margin-right:5px;
        }

        .article-item-wrap:nth-child(4n+4),
        .article-item-wrap:last-child {
            margin-left:5px;
            margin-right:5px;
        }
    }
</style>


// WEBPACK FOOTER //
// market-item.vue?47fe9c18